import { Api } from '@/interface/api';

const BASEURL = '/api/project/proxy';

/**
 * 赛道和竞赛
 * */

const getProjectRace: Api = {
    url: '/api/project/proxy/api/race-sys',
    method: 'get',
};

/**
 * 获取赛题
 */
const getProjectCompetitions: Api = {
    url: '/api/project/proxy/api/competitions',
    method: 'get',
};

// 获取赛题列表
const fetchCompetitions: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'get',
};

// 获取赛题详情
const fetchCompetitionDetails: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'get',
};

// 隐私赛题验证码校验
const postPrivateVerify: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'post',
};

// 获取我参加的赛题
const fetchUsersCmpHistory: Api = {
    url: `${BASEURL}-token/api/users/cmpHistory`,
    method: 'get',
};

// 获取我参加的赛题
const fetchActivityList: Api = {
    url: `${BASEURL}-token/api/activity/list`,
    method: 'get',
};

// 获取新闻动态
const fetchInformationsJson: Api = {
    url: '/api/project/proxy/api/informations.json',
    method: 'get',
};

// 活动详情
const fetchActivityDetail: Api = {
    url: `${BASEURL}-token/api/activity`,
    method: 'get',
};

// 活动浏览记录
const addActivityView: Api = {
    url: `${BASEURL}-token/api/activity/addActivityView`,
    method: 'post',
};

// 活动列表页浏览记录
const addActivityStaticView: Api = {
    url: `${BASEURL}-token/api/activity/addActivityStaticView`,
    method: 'post',
};

// 活动报名
const activityApply: Api = {
    url: `${BASEURL}-token/api/activity/apply`,
    method: 'post',
};

// 查询活动评论列表
const fetchActivityCommunicateList: Api = {
    url: `${BASEURL}-token/api/activity/communicate/list`,
    method: 'get',
};

// 点赞
const activityCommunicateLikesUpdate: Api = {
    url: `${BASEURL}-token/api/activity/communicate/likes/update`,
    method: 'post',
};

// 活动评论
const activityCommunicateUpdate: Api = {
    url: `${BASEURL}-token/api/activity/communicate/update`,
    method: 'post',
};

// 新闻详情
const fetchAdjacentInformation: Api = {
    url: '/api/project/proxy/api/adjacent-information',
    method: 'get',
};

// 新闻详情
const fetchPageInformation: Api = {
    url: '/api/project/proxy/api/page-information',
    method: 'get',
};

// 报名参赛
const postCmptSignup: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'post',
};
// 完善报名表
const putCmptSignup: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'put',
};

// 完善报名表
const putCmptSignupV2: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'put',
};

// 获取用户信息
const fetchUserInfo: Api = {
    url: `${BASEURL}-token/api/v2/users/info`,
    method: 'get',
};

// 保存技术标签
const relationSkillTags: Api = {
    url: `${BASEURL}-token/api/v2/users/tags/skills`,
    method: 'post',
};
// 保存行业标签
const relationIndustryTags: Api = {
    url: `${BASEURL}-token/api/v2/users/tags/industry`,
    method: 'post',
};
// 删除技术/行业标签关联
const removeTags: Api = {
    url: `${BASEURL}-token/api/v2/users/tags`,
    method: 'delete',
};
// 删除行业标签关联
// const removeIndustryTags: Api = {
//     url: `${BASEURL}-token/api/v2/users/tags`,
//     method: 'delete',
// };
// 获取技术标签
const fetchSkillTags: Api = {
    url: `${BASEURL}-token/api/v2/users/common-tags/tags`,
    method: 'get',
};
// 获取行业标签
const fetchIndustryTags: Api = {
    url: `${BASEURL}-token/api/v2/users/common-tags/industry`,
    method: 'get',
};
// 保存学历/就业信息
const saveIdenInfo: Api = {
    url: `${BASEURL}-token/api/v2/users/iden`,
    method: 'post',
};
const saveIdenInfoV2: Api = {
    url: `${BASEURL}-token/api/v2/users/iden-v2`,
    method: 'post',
};
// 报名
const signup: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'post',
};
// 查找学校
const searchSchool: Api = {
    url: `${BASEURL}-token/api/users/schools/search`,
    method: 'get',
};
// 查找专业
const searchMajor: Api = {
    url: `${BASEURL}-token/api/users/major/search`,
    method: 'get',
};
// 查找公司
const searchCompany: Api = {
    url: `${BASEURL}-token/api/users/company/search`,
    method: 'get',
};
// 查找职位
const searchJob: Api = {
    url: `${BASEURL}-token/api/users/job/search`,
    method: 'get',
};
// 更新所在地
const updateLocation: Api = {
    url: `${BASEURL}-token/api/users/updateLocation`,
    method: 'put',
};
// 创建所在地
const createLocation: Api = {
    url: `${BASEURL}-token/api/users/updateLocation`,
    method: 'post',
};
// 更新生日
const updateBirthday: Api = {
    url: `${BASEURL}-token/api/users/updateBirthday`,
    method: 'put',
};
// 获取城市信息
const initData: Api = {
    url: `${BASEURL}-token/api/users/initData`,
    method: 'get',
};
// 实名认证
const postAuth: Api = {
    url: `${BASEURL}-token/api/users/auth`,
    method: 'post',
};

// 获取学校
const schoolsSearch: Api = {
    url: `${BASEURL}-token/api/users/schools/search`,
    method: 'get',
};

// 获取专业
const majorSearch: Api = {
    url: `${BASEURL}-token/api/users/major/search`,
    method: 'get',
};

// 获取用户信息
const fetchUserV2: Api = {
    url: `${BASEURL}-token/api/v2/users/info`,
    method: 'get',
};

// 获取用户信息
const saveSkill: Api = {
    url: `${BASEURL}-token/api/v2/users/tags/skills`,
    method: 'post',
};

//保存行业领域方向标签
const saveIndustry: Api = {
    url: `${BASEURL}-token/api/v2/users/tags/industry`,
    method: 'post',
};

//获取数据集配置
const getConfigDwqDatasets: Api = {
    url: `${BASEURL}/api/dwq/config/datasets`,
    method: 'get',
};

// 上传文件
const postCmptSubmit: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'post',
    uploads: true,
};

// 获取历史记录
const postCmptSubmitReord: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'get',
};

// 提交文件
const postCmptSubmitForm: Api = {
    url: `${BASEURL}-token/api/competitions`,
    method: 'post',
};

// 获取首页热门赛题
const getHomeHotCmpt: Api = {
    url: `${BASEURL}/api/v3/page-choices.json`,
    method: 'get',
};

// 获取每道赛题是否关联邀请有奖活动
const getCmptRelationActivitys: Api = {
    url: `${BASEURL}/api/v1/race-specials/wap/relation-cmpts`,
    method: 'get',
};

// 获取活动邀请报名信息
const getRaceActivityInfo: Api = {
    url: `${BASEURL}/api/v1/race-specials/wap/activity`,
    method: 'get',
};

// 获取活动邀请排行榜
const getRaceActivityRankList: Api = {
    url: `${BASEURL}/api/v1/race-special/wap/activity/get-rank`,
    method: 'get',
};

const getSelfInviteList: Api = {
    url: `${BASEURL}-token/api/v1/race-special/wap/activity/get-self-invite`,
    method: 'get',
};

// 修改头像
const userAvatarUpload: Api = {
    url: `${BASEURL}-token/api/users/avatarUpload`,
    method: 'post',
    uploads: true,
};

// 获取首页赛题与赛事
const getHomeRecommendRaces: Api = {
    method: 'get',
    url: `${BASEURL}/api/wap/v1/home/choice/recommend-races`,
};

// // 获取赛事列表
// const fetchSpecialsList: Api = {
//     method: 'get',
//     url: `${BASEURL}/api/wap/v1/specials/list`
// }

// 埋点
// 记录类型：
// 1：用户注册
// 2：用户登录
// 3：实名认证
// 4：访问活动详情页
// 5：访问活动海报页
// 6：扫码活动页二维码
// 7：点击按钮参加比赛
const createOperationRecord: Api = {
    url: `${BASEURL}/api/wap/v1/analysis/operation-record`,
    method: 'post',
};

// 资讯
// 全部 /api/informations.json?pageIndex=1&homeShow=0&label=0
// 资讯 /api/informations.json?pageIndex=1&homeShow=0&label=2
// 活动 /api/informations.json?pageIndex=1&homeShow=0&label=1
// 其他 /api/informations.json?pageIndex=1&homeShow=0&label=3

export {
    getProjectRace,
    getProjectCompetitions,
    fetchCompetitions,
    fetchUsersCmpHistory,
    fetchInformationsJson,
    fetchActivityList,
    fetchAdjacentInformation,
    fetchPageInformation,
    fetchCompetitionDetails,
    postCmptSignup,
    fetchUserInfo,
    relationSkillTags,
    relationIndustryTags,
    removeTags,
    fetchSkillTags,
    fetchIndustryTags,
    saveIdenInfo,
    saveIdenInfoV2,
    signup,
    searchSchool,
    searchMajor,
    searchCompany,
    searchJob,
    updateLocation,
    updateBirthday,
    initData,
    postAuth,
    createLocation,
    schoolsSearch,
    majorSearch,
    fetchUserV2,
    saveSkill,
    saveIndustry,
    getConfigDwqDatasets,
    postCmptSubmit,
    postCmptSubmitReord,
    postCmptSubmitForm,
    getHomeHotCmpt,
    putCmptSignup,
    putCmptSignupV2,
    getCmptRelationActivitys,
    getRaceActivityInfo,
    getRaceActivityRankList,
    getSelfInviteList,
    userAvatarUpload,
    createOperationRecord,
    getHomeRecommendRaces,
    // fetchSpecialsList,
    postPrivateVerify,
    fetchActivityDetail,
    activityApply,
    addActivityView,
    addActivityStaticView,
    fetchActivityCommunicateList,
    activityCommunicateLikesUpdate,
    activityCommunicateUpdate,
};
